import React, {useMemo} from "react";
import PageHeader from "@components/Page/PageHeader";
import {findFirstSection, findSections, getCmsPage} from "@lib/Cms/CmsUtils";
import {SECTION_TYPE} from "@lib/Cms/CmsModels";
import PageSection from "@components/Page/PageSection";
import {Button, Disclosure, DisclosureGroup, DisclosurePanel, Heading} from "react-aria-components";
import {ChevronUpIcon} from "@components/Icons/ChevronUpIcon";
import {buildLinkUrl} from "@router/RouterUtils";
import {NavLink, useSearchParams} from "react-router-dom";
import "./FaqsPage.scss";
import {ChevronRightIcon} from "@components/Icons/ChevronRightIcon";
import Page from "@components/Page/Page";
import PageContent from "@components/Page/PageContent";
import KvBanner from "@components/KvBanner/KvBanner";

export default function FaqsPage() {

    const {sections, banner, ...page} = useMemo(() => getCmsPage("faq") ?? {}, []);

    const defaultSection = useMemo(() => findFirstSection(sections, SECTION_TYPE.DEFAULT), [sections]);
    const faqs = useMemo(() => findSections(defaultSection?.sections, SECTION_TYPE.FAQ), [defaultSection]);
    const contactSection = useMemo(() => findFirstSection(sections, SECTION_TYPE.MORE), [sections]);

    const [s] = useSearchParams();
    const showBannerContent = s.has("contentOnBanner");

    return (
        <>
            <Page>

                {!!banner &&
                    <KvBanner name={"faq"} banner={banner} showContent={showBannerContent}/>
                }

                {!showBannerContent && <PageHeader cms={page}/>}

                <PageContent>

                    <PageSection bg={defaultSection?.options?.bgType}>

                        <div className="faqs-container">

                            {!!contactSection &&
                                <div className="contact">
                                    <h3 className={"tp-2xl semibold"}>{contactSection.title}</h3>
                                    <p className={"tp-m light"}>{contactSection.text}</p>
                                    {contactSection.cta && contactSection.cta?.length && contactSection.cta[0] &&
                                        <NavLink to={buildLinkUrl(contactSection.cta[0].scope)}
                                                 className={"tp-xs color-primary semibold"}>
                                            <span className={"label"}>{contactSection.cta[0].title}</span>
                                            <span className={"icon"}>
                                                <ChevronRightIcon/>
                                            </span>
                                        </NavLink>
                                    }
                                </div>
                            }

                            {!!faqs && faqs.length > 0 &&
                                <div className="faqs">
                                    {!!defaultSection && defaultSection.title &&
                                        <h3 className={"tp-2xl semibold"}>{defaultSection.title}</h3>
                                    }
                                    <DisclosureGroup>
                                        {faqs.map((faq, index) =>
                                            <Disclosure key={`faq_${index}`}>
                                                <Heading level={4}>
                                                    <Button slot="trigger" className="disclosure-button">
                                                        <strong className={"tp-m semibold"}
                                                                dangerouslySetInnerHTML={{__html: faq.title ?? ""}}/>
                                                        <span><ChevronUpIcon/></span>
                                                    </Button>
                                                </Heading>
                                                <DisclosurePanel>
                                                    <p className={"tp-xs"}
                                                       dangerouslySetInnerHTML={{__html: faq.text ?? ""}}/>
                                                </DisclosurePanel>
                                            </Disclosure>
                                        )}
                                    </DisclosureGroup>
                                </div>
                            }

                        </div>

                    </PageSection>

                </PageContent>

            </Page>

        </>
    );
}
